import React from "react";
import { Input } from "@/components/ui/input";

interface AmountRangeFilterFieldsProps {
  minAmount: string;
  maxAmount: string;
  onChange: (key: "minAmount" | "maxAmount", value: string) => void;
  labels: { min: string; max: string };
  placeholders: { min: string; max: string };
}

/** The min/max amount pair of inputs the transaction and receivable filter panels share. */
const AmountRangeFilterFields = ({
  minAmount,
  maxAmount,
  onChange,
  labels,
  placeholders,
}: AmountRangeFilterFieldsProps) => (
  <>
    {([
      { key: "minAmount", value: minAmount, label: labels.min, placeholder: placeholders.min },
      { key: "maxAmount", value: maxAmount, label: labels.max, placeholder: placeholders.max },
    ] as const).map((field) => (
      <div key={field.key} className="space-y-2">
        <label className="text-sm font-medium">{field.label}</label>
        <Input
          type="number"
          placeholder={field.placeholder}
          value={field.value}
          onChange={(e) => onChange(field.key, e.target.value)}
        />
      </div>
    ))}
  </>
);

export default AmountRangeFilterFields;
